import { queryOptions } from "@tanstack/react-query"
import axios from "axios"
import {
  ConversationResponsesResponseDataSchema,
  DataResponseWithPagination,
  GetConversationsResponsesSchema,
} from "schema"
import { z } from "zod"

type Response = DataResponseWithPagination<z.infer<typeof ConversationResponsesResponseDataSchema>>

type Options = {
  query: z.input<typeof GetConversationsResponsesSchema>
  refetchInterval?: number
  onSuccess?: (data: Response) => void
}

export const conversationsResponsesQuery = (options: Options) => {
  return queryOptions({
    queryKey: ["conversations", "responses", JSON.stringify(options.query)],
    queryFn: async () => {
      const response = await axios.get<Response>(`/conversations/responses`, {
        params: options.query,
      })
      options.onSuccess?.(response.data)
      return response.data.data
    },
    refetchInterval: options.refetchInterval,
  })
}
